const heb = () => {
    return {
        arias: {
            stepper: {
                start: "הינך נמצא בשלב",
                end: "מתוך"
            },
            back_button: "אחורה",
            cover_selection: "כריכה מספר",
            image_to_load: "העלאת תמונה",
            image_load: "מעלה תמונה",
            loaded_image: "תמונה שהועלתה",
            customer_image: "תמונת הלקוח",
            exampleDialogTitle: "דוגמא של תמונות",
            payDialogTitle: "יש לבחור סוג ספר",
            templateInfoDialogTitle: "מידע על הטמפליט",
            next: "קודם",
            prev: "הצג אפשרויות נוספות",
            choose_template: "רשימה של נושאים",
            close: "סגור",
            more_info_about_template: "הצג מידע נוסף לנושא",
            levels: {
                level: "והנך צריך",
                upload_image: "לעלות תמונה",
                fill_info: "למלא נתונים רלוונטיים עבור הלקוח",
                choose_appearance: "לבחור מראה",
                choose_template: "לבחור תבנית"
            },
            book_image_preview: "תמונת עמוד",
            preview_book: {
                cover: "דוגמה לדף כריכה",
                image: "דוגמה לדף תמונה",
                text: "דוגמה לדף טקסט",
                mini_image: "דוגמה לתמונה מספר"
            }
        },
        general: {
            next: "השלב הבא",
            pageTitle: "יצירת ספר"
        },
        error: {
            error_upload: "עלייך לבחור תמונה כדי להמשיך",
            error_stage: "עלייך למלא את כל הפרטים כדי להמשיך",
            error_creation: "הייתה בעיה ביצירת הספר..",
            error_template: "עלייך לבחור טמפלט לפני שאתה ממשיך ליצירת הספר!",
            many_faces: "היי, זיהינו יותר מפרצוף אחד בתמונה, נסו שוב"
        },
        click_me: "לחץ עלי",
        choose: "בחירה",
        i_want_this_template: "אני רוצה את הסיפור הזה",
        shop_now: "קנה עכשיו",
        last_seen: "נראה לאחרונה"
    };
};

export default heb;
